module.exports = __webpack_public_path__ + "img/18.5b3836d2.gif";